export const TOGGLE_DEAL_MODE = 'TOGGLE_DEAL_MODE';
